import { MenuItem } from '../../models';

/** holds items for my progress dropdown used in navbar */
export const STUDY_HABITS_NAV: MenuItem[] = [
  { title: 'Daily Schedule', link: '/practice-schedule' },
  { title: 'Study Visualizer', link: '/habits/visualizer' },
];
